/* src/app/workshop/components/defects/edit-defect/edit-defect.component.scss */
/*# sourceMappingURL=edit-defect.component.css.map */
